import React from "react";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { MotifButton } from "@ey-xd/motif-react";

export const ConfirmDialog = ({ open, onClose, onConfirm }) => {
  return (
    <Dialog onClose={onClose} open={open} className="custom-dialog">
      <DialogTitle>Confirm</DialogTitle>

      <IconButton
        onClick={onClose}
        sx={{
          position: "absolute",
          right: 8,
          top: 8,
        }}
      >
        <CloseIcon />
      </IconButton>

      <DialogContent dividers className="modal-content">
        <span>
          <b>Please confirm the insights changes</b>
        </span>
        <p>
          Please click on confirm if you want to update the changes. Please note
          that once you click on confirm, insights selected will be updated to
          the system.
        </p>
      </DialogContent>

      <DialogActions>
        <MotifButton
          onClick={onClose}
          size="medium"
          type="button"
          variant="secondary"
        >
          Cancel
        </MotifButton>
        <MotifButton onClick={onConfirm} size="medium" type="button">
          Confirm
        </MotifButton>
      </DialogActions>
    </Dialog>
  );
};
